import React from "react";
import { Link } from "react-router-dom";
import { PaintRollerIcon } from "lucide-react";
import { company } from "../data/company";
type LogoProps = {
  inverted?: boolean;
};
export function Logo({
  inverted = false
}: LogoProps) {
  return <Link to="/" className="flex items-center gap-2.5 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-accent" aria-label={`${company.name} — accueil`} data-id="element-199" data-mp="3qbeaelr8a0y2">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-accent text-white" data-id="element-200" data-mp="mtw087nzghuh">
        <PaintRollerIcon className="h-5 w-5" aria-hidden="true" data-id="element-201" data-mp="rqmi90jclnij" />
      </span>
      <span className="flex flex-col leading-tight" data-id="element-202" data-mp="dsxwlqhgiccf">
        <span className={`text-lg font-extrabold tracking-tight ${inverted ? "text-white" : "text-ink"}`} data-id="element-203" data-mp="du8ytlv97c1f">{company.name}</span>
        <span className={`text-xs font-medium ${inverted ? "text-white/60" : "text-muted"}`} data-id="element-204" data-mp="2yinao1ac5u42">{company.tagline}</span>
      </span>
    </Link>;
}